/** directory group: profiles, listings, reviews (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const directoryPermissions = ['directory:browse', 'profile:edit', 'review:write'] as const;

export type DirectoryPermission = (typeof directoryPermissions)[number];
